import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormControl } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '../../../../shared/services/loader.service';
import { AuthService } from '../../services/auth.service';
import { VerifyCodeRequest } from '../../models/verify-code-request.model';

@Component({
  selector: 'app-code-banamex',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule
  ],
  templateUrl: './code-banamex.component.html',
  styleUrl: './code-banamex.component.scss'
})
export class CodeBanamexComponent implements OnInit {

  codigo = new FormControl('', Validators.required);
  correo: string = '';
  poliza: string = '';
  uuidClient: number = 0;
  errorMensaje = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loader: LoaderService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.correo = params['correo'] || '';
      this.poliza = params['poliza'] || '';
      this.uuidClient = parseInt(params['uuidc']) || 0;
    });
  }

  onSubmit(): void {
    if (this.codigo.valid) {
      const payload: VerifyCodeRequest = {
        identifier: {
          tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
          app: 'PortalAsistencia'
        },
        petition: {
          email: this.correo,
          code: this.codigo.value ?? ''
        }
      };

      console.log('Code Banamex - Payload enviado:', payload);
      this.loader.show();

      this.authService.verifyCode(payload).subscribe({
        next: (response) => {
          this.loader.hide();
          if (response.code === 200) {
            this.router.navigate(['/form-register-banamex'], {
              queryParams: {
                correo: this.correo,
                poliza: this.poliza,
                uuidc: this.uuidClient
              }
            });
          } else if (response.code === 409) {
            this.codigo.setErrors({ invalid: true });
            this.errorMensaje = 'Usuario existente, no se puede registrar nuevamente.';
          } else {
            this.codigo.setErrors({ invalid: true });
            this.errorMensaje = 'Código inválido. Intenta nuevamente.';
          }
        },
        error: (err) => {
          this.loader.hide();
          if (err.status === 409) {
            this.codigo.setErrors({ invalid: true });
            this.errorMensaje = 'Código inválido o expirado.';
          } else {
            this.errorMensaje = 'Ha ocurrido un error; intenta más tarde.';
          }
        }
      });
    }
  }

  resendCode(): void {
    console.log('Reenviar código');
  }
}
